/**
 * @file progress-state.icon.tsx
 * @description Компонент для отображения иконки статуса задачи в работе.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [classnames]
 */

import cn from 'classnames';
import { IIconProps } from '@src/types';

export const ProgressTaskStateIcon = ({
    className,
    size = '1.6937vmin',
    color = '#4B6178',
    onClick,
    ...props
}: IIconProps) => {
    return (
        <div className={cn(className, { 'cursor-pointer': onClick })} onClick={onClick} style={{ color }} {...props}>
            <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.6198 2.05094C9.8015 1.69068 8.91768 1.50311 8.02358 1.49994L8.02889 0C9.12932 0.00389543 10.2171 0.234757 11.2242 0.678151C12.2314 1.12154 13.1362 1.76794 13.8822 2.57691C14.6281 3.38588 15.1991 4.34004 15.5595 5.37972C15.9199 6.4194 16.0619 7.52225 15.9767 8.61932C15.8915 9.71638 15.5808 10.7841 15.0642 11.7556C14.5475 12.7272 13.836 13.5817 12.974 14.2657C12.1121 14.9498 11.1183 15.4487 10.0547 15.7312C8.99118 16.0138 7.88079 16.0739 6.79297 15.9078L7.01939 14.425C7.90325 14.56 8.80544 14.5111 9.66956 14.2816C10.5337 14.052 11.3412 13.6467 12.0415 13.0909C12.7418 12.5351 13.32 11.8408 13.7397 11.0514C14.1595 10.262 14.4119 9.3945 14.4812 8.50314C14.5504 7.61177 14.435 6.71571 14.1422 5.87096C13.8494 5.02622 13.3854 4.25097 12.7794 3.59368C12.1733 2.93639 11.4381 2.4112 10.6198 2.05094Z"
                    fill="currentcolor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.62097 1.64864C6.35479 1.70639 6.0925 1.78082 5.83566 1.87147L5.33637 0.457053C5.65248 0.345477 5.97529 0.253878 6.30289 0.182799L6.62097 1.64864Z"
                    fill="currentcolor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.75074 2.37163C4.51486 2.50781 4.28777 2.65868 4.07082 2.82334L3.1639 1.62859C3.43091 1.42592 3.71041 1.24024 4.00072 1.07263L4.75074 2.37163Z"
                    fill="currentcolor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.40223 3.40492C3.20964 3.59751 3.02934 3.80201 2.8624 4.01721L1.67714 3.09788C1.8826 2.83301 2.10451 2.58132 2.34155 2.34429L3.40223 3.40492Z"
                    fill="currentcolor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.3687 4.75123C2.23251 4.9871 2.11128 5.23129 2.00574 5.48237L0.622912 4.90112C0.752816 4.5921 0.902017 4.29155 1.06963 4.00125L2.3687 4.75123Z"
                    fill="currentcolor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.72002 6.31925C1.64953 6.58233 1.59564 6.84958 1.55867 7.11942L0.0725182 6.91585C0.118013 6.58374 0.184338 6.25482 0.271101 5.93104L1.72002 6.31925Z"
                    fill="currentcolor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.49952 8.00195C1.49952 8.27431 1.51664 8.5464 1.55078 8.81661L0.062578 9.0046C0.0205621 8.67204 -0.000507846 8.33716 -0.000507832 8.00195L1.49952 8.00195Z"
                    fill="currentcolor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.72002 9.68441C1.79052 9.94749 1.87748 10.2059 1.98039 10.458L0.591556 11.0248C0.464893 10.7144 0.357864 10.3964 0.271101 10.0726L1.72002 9.68441Z"
                    fill="currentcolor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.3687 11.2527C2.50488 11.4885 2.65576 11.7156 2.82044 11.9326L1.62562 12.8394C1.42294 12.5724 1.23724 12.293 1.06963 12.0027L2.3687 11.2527Z"
                    fill="currentcolor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.40223 12.598C3.59483 12.7906 3.79934 12.9709 4.01456 13.1378L3.09518 14.323C2.8303 14.1176 2.57859 13.8957 2.34155 13.6586L3.40223 12.598Z"
                    fill="currentcolor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.75074 13.6313C4.98662 13.7675 5.23083 13.8887 5.48192 13.9942L4.90063 15.377C4.5916 15.2471 4.29104 15.0979 4.00072 14.9303L4.75074 13.6313Z"
                    fill="currentcolor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.68654 4.12915C8.10076 4.12915 8.43656 4.46493 8.43656 4.87913V8.12902H11.6866C12.1008 8.12902 12.4366 8.4648 12.4366 8.879C12.4366 9.2932 12.1008 9.62897 11.6866 9.62897H6.93652V4.87913C6.93652 4.46493 7.27232 4.12915 7.68654 4.12915Z"
                    fill="currentcolor"
                />
            </svg>
        </div>
    );
};
